const logoSrc = '/images/Adsperianx%20Logo-01.png';

export default function ComingSoon() {
  return (
    <div className="coming-soon-page">
      <div aria-hidden className="coming-soon-glow coming-soon-glow--left" />
      <div aria-hidden className="coming-soon-glow coming-soon-glow--right" />

      <main className="coming-soon-content">
        <img
          src={logoSrc}
          alt="ADSPERIANX SOLUTIONS"
          className="coming-soon-logo"
          width={280}
          height={280}
        />

        <div className="coming-soon-divider" aria-hidden />

        <p className="coming-soon-eyebrow">ADSPERIANX SOLUTIONS</p>

        <h1 className="coming-soon-heading">Coming Soon</h1>

        <p className="coming-soon-tagline">
          A boutique software firm — crafting something thoughtful for you.
        </p>
      </main>

      <footer className="coming-soon-footer">
        &copy; {new Date().getFullYear()} ADSPERIANX SOLUTIONS
      </footer>
    </div>
  );
}
